import React from 'react';
import { FlatList } from 'react-native';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { SubTrayItemView } from '../../../CommonUI';
import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './PaymentMethodOptions.Styles';

const PaymentMethodOptions = ({ paymentMethodOptions, onItemPress, theme }) => {
  const renderPaymentMethodOption = ({ item }) => {
    const onPress = () => onItemPress(item.paymentType, item.onPress);

    return (
      <SubTrayItemView
        containerViewStyle={styles.itemContainerViewStyle}
        itemTitleStyle={styles.itemTitleStyle}
        image={item.itemImage}
        imageProps={{ style: styles.itemImageStyle }}
        {...item}
        onPress={onPress}
      />
    );
  };

  return (
    <>
      <VFText
        i18nKey="payment_method_options_title"
        style={styles.mainTitleStyle(theme)}
        testKey={FrameworkTestKeys.paymentMethodOptionsListTitle}
      />
      <FlatList
        horizontal={true}
        data={paymentMethodOptions}
        renderItem={renderPaymentMethodOption}
        testID={FrameworkTestKeys.paymentMethodOptionsList}
      />
    </>
  );
};
PaymentMethodOptions.defaultProps = {
  theme: LightThemeColors,
};

PaymentMethodOptions.propTypes = {
  paymentMethodOptions: PropTypes.array,
  onItemPress: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};
export default PaymentMethodOptions;
